// D3-02 (FE-1.4): official Microsoft four-square logo for the sign-in button.
// Microsoft's brand guidelines require their actual logo (not a generic icon)
// on "Sign in with Microsoft" buttons.
// Colors are the official Microsoft brand palette and intentionally not
// theme tokens.
export function MicrosoftLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 21 21"
      aria-hidden="true"
      focusable="false"
      role="presentation"
    >
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}

export default MicrosoftLogo;
